import React from 'react';
//import data from "../data"; 
import axios from "axios";


/* import {Link} from 'react-router-dom'; */

class Blogs extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
          blogList: [],          
        }

        this.getlogList();
      }
      getlogList(){ 

        var self = this;    
        var post_uri =window.API_URL+'blogs';
        axios.get(post_uri).then(function (response) {
            console.log(response);
           // alert(response);
           let sortd = response.data.sort((a, b) => new Date(b.publish_date) - new Date(a.publish_date))
            self.setState({blogList: sortd});
            })
            .catch(function (error) {
            alert(error); 
            });

      }

    render(){
        return(
            <div>
                 {/*  <!-- Section --> */}
                 <section>

                 <div className="inner_banner"  style={{  backgroundImage: `url("assets/images/banners/bolgbanner.jpg")` }}>
                        <div className="container">
                            <h1>Blogs</h1>
                        </div>
                    </div>

                <div className="inner_blog_bg">
                    {
                        this.state.blogList.length ==0 &&
                        <div className="container">
                                    <div className="row">
                                       <p>Loading...</p>  
                        </div>
                        </div>
                    },

                {
				   this.state.blogList.map((blogItem, i) => {
						return (
                            <div className="inner_blog" key={i} >
                                <div className="container">
                                    <div className="row ">
                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                                            <figure><img src={window.API_BLOG_IMG_URL+'/'+blogItem.image} alt="abput_img" /></figure>
                                        </div>
                                        <div className="col-xl-9 col-lg-9 col-md-9 col-sm-12">
                                            <h2 className="global_title"><span>{blogItem.title}</span></h2>
                                            <p><small>Publish : {blogItem.publish_date} | Created By : {blogItem.created_by} </small></p>
                                            
                                            {/* <p>{blogItem.details}</p> */}
                                            <div dangerouslySetInnerHTML={{ __html: blogItem.details }} />
                                            <br/>
                                            <a href={'/blogsview/'+ blogItem.id} className="btns">Read more</a>
                                        </div>
                                    
                                    </div>
                                </div>
                            </div>
							
						);
					})
				}


              

                {/* <div className="inner_blog">
                    <div className="container">
                        <div className="row ">
                            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                                <figure><img src="assets/images/abput_img_1.jpg" alt="abput_img" /></figure>
                            </div>
                            <div className="col-xl-9 col-lg-9 col-md-9 col-sm-12">
                                <h2 className="global_title"><span>Blog Title</span></h2>
                                <p>Suspendisse efficitur augue quis purus bibendum congue. Integer eu molestie lorem, vel vulputate risus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vivamus in consectetur turpis. Nullam vestibulum, eros eu sollicitudin consectetur, orci quam luctus erat, quis aliquet dui ligula et nulla. Donec facilisis sapien at erat maximus pellentesque. Ut pretium dapibus turpis, sed vestibulum mauris congue a. Nam lorem nulla, porta nec egestas quis, maximus sit amet quam.</p>
                                <a href="/" className="btns">Read more</a>
                            </div>
                           
                        </div>
                    </div>
                </div>


                <div class="typo_sec">
                    <div class="container">
                        <h1 class="text-center">main heading here</h1>
                        <p>Nullam nulla lorem, rutrum a laoreet non, auctor cursus orci. Donec libero odio, laoreet vel consequat in, viverra non diam. Quisque tincidunt leo tellus. In non fringilla metus, ac euismod ipsum. Aenean imperdiet fermentum porta. Praesent sed est tincidunt, mattis enim et, aliquam turpis. Suspendisse tempor, sem nec finibus pellentesque, justo sem aliquet odio, at consectetur purus lectus sed augue. Vivamus ac justo sed erat vehicula pretium vel a enim. Suspendisse potenti. Nunc pulvinar, magna et finibus ullamcorper, augue metus porta mauris, sed efficitur tortor justo sit amet sem. Vestibulum elementum mi et mauris feugiat cursus sit amet ac est. Quisque sapien lectus, sodales vel efficitur ac, vehicula sed turpis. Integer faucibus rhoncus tellus, in suscipit enim aliquam a. Donec tristique odio vel neque tristique lacinia. Proin vel finibus nulla, viverra lobortis leo. Maecenas tempus volutpat lacus a suscipit. Quisque porttitor purus in lacus convallis, id fermentum mauris tristique. Maecenas at ultrices tortor. Nunc ultricies tortor maximus lacus tristique fermentum. Integer eu vulputate urna. Vivamus iaculis lectus justo, quis bibendum velit pharetra eu. Aenean sed mauris nibh. Vivamus non justo sed dolor euismod gravida eu at enim. Nulla blandit interdum augue quis tempus. Sed in est varius, eleifend enim non, varius est.</p>
                        
                        <h2>Nunc a tristique dui</h2>
                        <p>are. Ut tincidunt faucibus nisl, convallis ullamcorper tortor fermentum nec. Maecenas ornare suscipit ornare. Suspendisse quis placerat enim, ac condimentum est. Aliquam orci purus, tempus vel massa malesuada, posuere vestibulum ligula. Phasellus vitae tincidunt nunc. Curabitur pretium semper ultricies. Suspendisse leo nisl, maximus eu erat at, ultrices placerat felis. Nullam et dui ut urna rhoncus bibendum. Nunc a tristique dui, vel tempor ipsum. Duis bibendum sed quam ac mollis. Suspendisse potenti. Sed posuere nec arcu quis volut</p>
                        
                        <h3>Nunc a tristique dui</h3>
                        <p>Nunc a tristique dui, vel tempor ipsum. Duis bibendum sed quam ac mollis. Suspendisse potenti. Sed posuere nec arcu quis volutpat. Sed vitae nisl mollis, tincidunt quam vel, ultrices nibh. Sed rutrum justo in purus sodales mollis. Nam non purus diam. In tempor odio eu sem volutpat, vel bibendum lacus ornare. Ut tincidunt faucibus nisl, convallis ullamcorper tortor fermentum nec. Maecenas ornare suscipit ornare. Suspendisse quis placerat enim, ac condimentum est. Aliquam orci purus, tempus vel massa malesuada, posuere vestibulum ligula. Phasellus vitae tincidunt nunc. Curabitur pretium semper ultricies. Suspendisse leo nisl, maximus eu erat at, ultrices placerat felis. Nullam et dui ut urna rhoncus bibendum. Nunc a tristique dui, vel tempor ipsum. Duis bibendum sed quam ac mollis. Suspendisse potenti. Sed posuere nec arcu quis volutpat. Sed vitae nisl mollis, tincidunt quam vel, ultrices nibh. Sed rutrum justo in purus sodales mollis. Nam non purus diam. In tempor odio eu sem volutpat, vel bibendum lacus ornare. Ut tincidunt faucibus nisl, convallis ullamcorper tortor fermentum nec. Maecenas ornare suscipit ornare. Suspendisse quis placerat enim, ac condimentum est. Aliquam orci purus, tempus vel massa malesuada, posuere vestibulum ligula. Phasellus vitae tincidunt nunc. Curabitur pretium semper ultricies. Suspendisse leo nisl, maximus eu erat at, ultrices placerat felis. Nullam et dui ut urna rhoncus bibendum.</p>
                        
                        <ul>
                            <li><a href="/#">Phasellus vitae tincidunt nun</a></li>
                            <li><a href="/#">cies. Suspendisse leo nisl, maximus eu </a></li>
                            <li><a href="/#">Sed rutrum justo in purus sodales mollis.</a></li>
                            <li><a href="/#">leo nisl, maximus eu erat at, ultrices placerat </a></li>
                            <li><a href="/#">entum nec. Maecenas ornare suscipit ornare. Suspendisse quis plac</a></li>
                        </ul>
                        
                        
                        <p>Nunc a tristique dui, vel tempor ipsum. Duis bibendum sed quam ac mollis. Suspendisse potenti. Sed posuere nec arcu quis volutpat. Sed vitae nisl mollis, tincidunt quam vel, ultrices nibh. Sed rutrum justo in purus sodales mollis. Nam non purus diam. In tempor odio eu sem volutpat, vel bibendum lacus ornare. Ut tincidunt faucibus nisl, convallis ullamcorper tortor fermentum nec. Maecenas ornare suscipit ornare. Suspendisse quis placerat enim, ac condimentum est. Aliquam orci purus, tempus vel massa malesuada, posuere vestibulum ligula. Phasellus vitae tincidunt nunc. Curabitur pretium semper ultricies. Suspendisse leo nisl, maximus eu erat at, ultrices placerat felis. Nullam et dui ut urna rhoncus bibendum. Nunc a tristique dui, vel tempor ipsum. Duis bibendum sed quam ac mollis. Suspendisse potenti. Sed posuere nec arcu quis volutpat. Sed vitae nisl mollis, tincidunt quam vel, ultrices nibh. Sed rutrum justo in purus sodales mollis. Nam non purus diam. In tempor odio eu sem volutpat, vel bibendum lacus ornare. Ut tincidunt faucibus nisl, convallis ullamcorper tortor fermentum nec. Maecenas ornare suscipit ornare. Suspendisse quis placerat enim, ac condimentum est. Aliquam orci purus, tempus vel massa malesuada, posuere vestibulum ligula. Phasellus vitae tincidunt nunc. Curabitur pretium semper ultricies. Suspendisse leo nisl, maximus eu erat at, ultrices placerat felis. Nullam et dui ut urna rhoncus bibendum.</p>
                        
                        
                        
                    </div>
                </div> */}
                </div>
                </section>
            </div>
            )
        }
    }
    export default Blogs